import React, { useEffect, useState } from 'react';
import { getDownloadURL, getStorage, ref, uploadBytes } from 'firebase/storage';
import { useDispatch } from 'react-redux';
import { showToast } from '@/features/toast/toastSlice';
import { useUpdateUserProfileMutation } from '@/features/user/userApi';
import { STORAGE_PURPOSES, userStoragePath } from '@/utils/storagePaths';
import { AvatarImagePicker } from '@/components/AvatarImagePicker';

export const ProfileAvatarEditor = ({
	userId,
	email,
	imageUrl = '',
	disabled = false,
	size = 200,
	onImageUrlChange,
	onUploadingChange,
}) => {
	const dispatch = useDispatch();
	const [previewUrl, setPreviewUrl] = useState(imageUrl || '');
	const [isImageUploading, setIsImageUploading] = useState(false);
	const [updateUserProfile] = useUpdateUserProfileMutation();

	useEffect(() => {
		setPreviewUrl(imageUrl ?? '');
	}, [imageUrl]);

	const setUploading = (nextValue) => {
		setIsImageUploading(nextValue);
		onUploadingChange?.(nextValue);
	};

	const handleCrop = async (blob, dataUrl) => {
		if (!userId || !email) return;
		try {
			setUploading(true);
			setPreviewUrl(dataUrl);

			const storage = getStorage();
			const storageRef = ref(
				storage,
				userStoragePath(userId, STORAGE_PURPOSES.profile, 'profile.jpg'),
			);
			await uploadBytes(storageRef, blob);

			const downloadUrl = await getDownloadURL(storageRef);
			setPreviewUrl(downloadUrl);
			onImageUrlChange?.(downloadUrl);
			await updateUserProfile({
				email,
				properties: { imageUrl: downloadUrl },
			}).unwrap();

			dispatch(showToast({ message: 'Image uploaded successfully!' }));
		} catch (err) {
			console.error('Error uploading image:', err);
			dispatch(showToast({ message: 'Error uploading image' }));
		} finally {
			setUploading(false);
		}
	};

	return (
		<AvatarImagePicker
			imageUrl={previewUrl}
			disabled={disabled}
			isUploading={isImageUploading}
			size={size}
			onCrop={handleCrop}
		/>
	);
};

export default ProfileAvatarEditor;
